/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../common/graphql/generated/types';

export type EditOrganizationMemberInvitationModal_OrganizationMemberInvitationFragment = { id: any, organizationMemberRoleId: any, invitedToOrganizationId: any | null };

export const EditOrganizationMemberInvitationModal_OrganizationMemberInvitationFragmentDoc = `
    fragment EditOrganizationMemberInvitationModal_OrganizationMemberInvitation on OrganizationMemberInvitations {
  id
  organizationMemberRoleId
  invitedToOrganizationId
}
    `;